import React from 'react'
import PropTypes from 'prop-types'
import {format} from 'ag-common/facades'

function DatePickerTitleCell({date}) {
  return <div className="date-picker-title-cell noselect">{format(date, 'MMMM yyyy')}</div>
}

DatePickerTitleCell.propTypes = {
  date: PropTypes.instanceOf(Date),
}

export default DatePickerTitleCell
